import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { App } from './app'
import { createApi } from './lib/api'
import { AppProviders } from './lib/providers'
import { createTokenStore } from './lib/token-store'
import './styles.css'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string
// A API atende em api.westhetics.io (T30); sem VITE_API_URL, no endereço do próprio projeto.
const apiUrl = (import.meta.env.VITE_API_URL as string | undefined) || `${supabaseUrl}/functions/v1`

const store = createTokenStore()
const api = createApi({
  baseUrl: apiUrl,
  anonKey,
  getAccessToken: () => Promise.resolve(store.get()),
  // 401: a sessão terminou (RN-POR-03). O token some e a tela de entrada diz o motivo.
  onUnauthenticated: () => store.clear('expired'),
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders api={api} store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProviders>
  </StrictMode>,
)
